var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { commonService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
import { Service } from '~/core/service';
var ReminderMessageService = /** @class */ (function (_super) {
    __extends(ReminderMessageService, _super);
    function ReminderMessageService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 获取未读消息数列表
     */
    ReminderMessageService.prototype.getUnReadCount = function (messageType) {
        return this.netService.send({
            server: commonService.reminderMessageController.getUnReadCount,
            data: {
                messageType: messageType
            }
        });
    };
    /**
     * 批量删除消息
     */
    ReminderMessageService.prototype.batchDelete = function (ids) {
        return this.netService.send({
            server: commonService.reminderMessageController.batchDelete,
            data: {
                ids: ids
            }
        });
    };
    /**
     * 获取消息列表
     * @param state 消息类型,分为已读、未读和全部
     */
    ReminderMessageService.prototype.getReminderMessages = function (state, messageType, page) {
        return this.netService.send({
            server: commonService.reminderMessageController.getReminderMessages,
            data: {
                state: state,
                messageType: messageType
            },
            page: page
        });
    };
    /**
     * 设置消息状态为已读
     * @param id
     */
    ReminderMessageService.prototype.setMessageRead = function (id) {
        return this.netService.send({
            server: commonService.reminderMessageController.setSelectedMessageRead,
            data: {
                id: id
            }
        });
    };
    ReminderMessageService.prototype.getWorkbenchReminder = function () {
        return this.netService.send({
            server: commonService.reminderMessageController.getWorkbenchReminder,
        });
    };
    __decorate([
        Inject(NetService)
    ], ReminderMessageService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], ReminderMessageService.prototype, "batchDelete", null);
    __decorate([
        Debounce()
    ], ReminderMessageService.prototype, "setMessageRead", null);
    return ReminderMessageService;
}(Service));
export { ReminderMessageService };
